import React from 'react';

const Meanwhile = () => {
    return (
        <div>
            <section
                className="section section-lg section-lead section-bold section-theme-autoheight section-theme-lighten section-eyebrow-include section-theme-indent-bottom-inside-md section-theme-indent-bottom-inside-lg-option section-theme-indent-no-bottom-outside  section-24 section-i8">
                <div className="container">
                    <div className="row">
                        <div
                            className="section-content-wrapper col-lg-10 col-lg-offset-1 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12">
                            <div className="section-content">
                                <div className="section-content-caption"><p className="section-eyebrow">Meanwhile</p>
                                    <h2>One more thing.</h2>
                                    <p>Currently, we have been developing a unique platform for the communication of
                                        gamers and video game developers.</p>
                                    <blockquote><p>In the future, the bears will become mascots of our project, and each
                                        holder of a unique NFT CyberBearz Army card will receive bonuses and privileges
                                        in our future project.</p></blockquote>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-option container">
                    <div className="strip-wrapper row">
                        <div
                            className="col-lg-12 col-lg-offset-0 col-md-8 col-md-offset-2  col-sm-10 col-sm-offset-1 col-xs-12">
                            <div className="strip-items strip-center">
                                <div className="strip strip-sm">
                                    <figure className="strip-icon icon icon-lg icon-guilch"></figure>
                                    <div className="strip-caption"><h3 className="h5">GUILCH</h3>
                                        <p>A new service for the creation of public orders in the field of computer
                                            gaming.</p></div>
                                </div>
                                <div className="strip strip-sm">
                                    <figure className="strip-icon icon icon-lg icon-stock"></figure>
                                    <div className="strip-caption"><h3 className="h5">Rise in price</h3>
                                        <p>After the launch of the service, NFT CyberBearz Army cards will rise in
                                            price. Let's say, this is an investment.<sup>2</sup></p></div>
                                </div>
                                <div className="strip strip-sm">
                                    <figure className="strip-icon icon icon-lg icon-ticket"></figure>
                                    <div className="strip-caption"><h3 className="h5">Becoming a ticket</h3>
                                        <p>NFT CyberBearz Army holders will have the opportunity to be the first to try
                                            our products.</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </section>
        </div>
    );
};

export default Meanwhile;